/**
 * 响应数据
 */
export interface RankGamesData {
  /**
   * 是否有更多信息，用于是否还继续下一页请求
   */
  hasMore: boolean;
  /**
   * 定位信息
   */
  nextCursor: string;
  /**
   * 请求的页大小
   */
  pageSize: number;
  /**
   * 游戏列表
   */
  records: Record[];
  /**
   * 当前页的数据数量
   */
  recordSize: number;
  [property: string]: any;
}

export interface Record {
  /**
   * 业务信息
   */
  bizInfo?: null | BizInfo;
  /**
   * 记录特征值
   */
  feature?: null | Feature;
  /**
   * 游戏ID
   */
  gameId: number;
  /**
   * 游戏标签，游戏标签数组
   */
  gameLabels?: GameLabel[];
  /**
   * 游戏启动信息
   */
  gameLaunch?: GameLaunch;
  /**
   * 游戏logo，游戏logo地址
   */
  gameLogo: string;
  /**
   * 游戏名称
   */
  gameName: string;
  /**
   * 是否为新游
   */
  isNewGame: boolean;
  /**
   * 消息块，显示 游戏奖项或榜单相关信息
   */
  messageBlock?: null | MessageBlock;
  /**
   * 序号
   */
  rankSeq: number;
  [property: string]: any;
}

export interface BizInfo {
  /**
   * 是否直播中
   */
  isLiving: boolean;
  /**
   * 是否支付云手机，不存在即为不支持
   */
  isSupportCloud: boolean;
  [property: string]: any;
}

export interface Feature {
  /**
   * 游戏GQS
   */
  gameGqs: number;
  /**
   * 推荐分值，排序分值
   */
  score?: number;
  [property: string]: any;
}

export interface GameLabel {
  /**
   * 标签名称
   */
  name: string;
  [property: string]: any;
}

/**
 * 游戏启动信息
 */
export interface GameLaunch {
  /**
   * 游戏加载信息，当method为ENGINE时不存在
   */
  loadingInfo?: null | LoadingInfo;
  /**
   * 启动方式
   */
  method: Method;
  [property: string]: any;
}

export interface LoadingInfo {
  /**
   * APPID，为PC时存在
   */
  appId?: null | string;
  /**
   * 下载地址
   */
  downloadUrl: string;
  /**
   * 游戏包名，为安卓时存在
   */
  package?: null | string;
  /**
   * 版本信息
   */
  versionName?: null | string;
  [property: string]: any;
}

/**
 * 启动方式
 */
export enum Method {
  Engine = 'ENGINE',
  External = 'EXTERNAL',
  Liufang = 'LIUFANG',
  Web = 'WEB'
}

export interface MessageBlock {
  /**
   * 文案
   */
  text: string;
  /**
   * 消息块类型
   */
  type: Type;
  /**
   * 高亮开关，true需要解析&lt;highlight&gt;注：高亮标签不一定有
   */
  highlightEnable: boolean;
  [property: string]: any;
}

/**
 * 消息块类型
 */
export enum Type {
  Award = 'AWARD',
  RankDesc = 'RANK_DESC'
}
